module.exports = __webpack_public_path__ + "static/media/icon-user.13677853.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/icon-user.svg
// module id = 402
// module chunks = 0 1 2